import React from "react";
import { Button, Tag } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { SETUP_STATUS } from "../readiness";

const tagMap = {
  [SETUP_STATUS.complete]: { color: "green", label: "Complete" },
  [SETUP_STATUS.required]: { color: "red", label: "Required" },
  [SETUP_STATUS.optional]: { color: "orange", label: "Optional" },
  [SETUP_STATUS.skipped]: { color: "default", label: "Skipped" },
  [SETUP_STATUS.needsReview]: { color: "gold", label: "Needs attention" },
};

export const StatusTag = ({ status }) => {
  const cfg = tagMap[status] || tagMap[SETUP_STATUS.optional];
  return <Tag color={cfg.color}>{cfg.label}</Tag>;
};

const ReadinessSummary = ({ title = "Already in system", items = [], status, loading, onRefresh }) => {
  return (
    <div className="onb-readiness">
      <div className="onb-readiness-head">
        <div>
          <div className="onb-readiness-title">{title}</div>
          <div className="onb-readiness-sub">Review current data before making changes.</div>
        </div>
        <div className="onb-readiness-actions">
          {status ? <StatusTag status={status} /> : null}
          {onRefresh ? (
            <Button size="small" icon={<ReloadOutlined />} loading={loading} onClick={onRefresh}>
              Refresh existing data
            </Button>
          ) : null}
        </div>
      </div>
      <div className="onb-readiness-grid">
        {items.map((item) => (
          <div className="onb-readiness-item" key={item.label}>
            <div className="n">{item.value}</div>
            <div className="l">{item.label}</div>
            {item.help ? <div className="h">{item.help}</div> : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReadinessSummary;
